// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"86f11ad9","196":"d1165f76","344":"c036cbea","389":"4b9551de","605":"0df9ae7d","606":"7b32566e","716":"c8e2cedb","858":"c1f4c689","962":"0a5a6951"}[chunkId] + ".chunk.js";
};